import { ServerDate } from "helpers/server-date.class"

export const calculateAdditionalProgress = (
  finishTime: number | null,
  startTime: number | null,
  adjustedSpeed: number
) => {
  const now = ServerDate.now()
  const finish = finishTime ? finishTime : now
  const nowOrFinish = Math.min(finish, now)

  const timePassed = startTime ? nowOrFinish - startTime : 0

  // const roundedTimePassed = Math.floor(timePassed / 1000) * 1000
  const roundedTimePassed = (timePassed / 1000) * 1000 + 1

  const speedPerMs = adjustedSpeed / (60 * 60 * 1000)
  const additionalProgress = roundedTimePassed * speedPerMs

  return additionalProgress
}
